// AppItem
import './index.css'

const AppItem = props => {
  const {appDetails} = props
  const {appName, imageUrl} = appDetails
  const playStoreUrl = `https://play.google.com/store/search?q=${encodeURIComponent(
    appName,
  )}&c=apps`

  return (
    <li className="app-item">
      <a
        href={playStoreUrl}
        target="__blank"
        rel="noopener noreferrer"
        className="app-link"
      >
        <img className="app-image" src={imageUrl} alt={appName} />
        <p className="app-name">{appName}</p>
      </a>
    </li>
  )
}

export default AppItem
